import SpecialtyTableContainer from './SpecialtyTableContainer';

export default SpecialtyTableContainer;